//# sourceMappingURL=weaviate.mjs.map
/// <reference types="./weaviate.d.mts" />
import * as $when from "../../../altar/altar/when.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $weaviate from "../../../data_types/data/weaviate.mjs";
import * as $button from "../../../ds/ds/components/button.mjs";
import * as $callout from "../../../ds/ds/components/callout.mjs";
import * as $dropdown from "../../../ds/ds/components/dropdown.mjs";
import * as $input from "../../../ds/ds/components/input.mjs";
import * as $label from "../../../ds/ds/components/label.mjs";
import * as $l from "../../../ds/ds/components/layout.mjs";
import * as $skeleton from "../../../ds/ds/components/skeleton.mjs";
import * as $table from "../../../ds/ds/components/table.mjs";
import * as $toggler from "../../../ds/ds/components/toggler.mjs";
import * as $typography from "../../../ds/ds/components/typography.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $compose from "../../../redraw_batteries/redraw/batteries/compose.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $e from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $h from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $function from "../../../tiamat/tiamat/function.mjs";
import * as $migration_effects from "../../admin/effects/weaviate.mjs";
import * as $card from "../../components/card.mjs";
import * as $store from "../../data/store.mjs";
import { Ok, toList, Empty as $Empty, CustomType as $CustomType } from "../../gleam.mjs";
import * as $common from "../../view/organization/common.mjs";

class CreateCollectionForm extends $CustomType {
  constructor(kind, variant) {
    super();
    this.kind = kind;
    this.variant = variant;
  }
}

class LaunchForm extends $CustomType {
  constructor(collection_kind, source_variant, target_variant, previous_run_id, batch_size, sleep, dry_run, overwrite) {
    super();
    this.collection_kind = collection_kind;
    this.source_variant = source_variant;
    this.target_variant = target_variant;
    this.previous_run_id = previous_run_id;
    this.batch_size = batch_size;
    this.sleep = sleep;
    this.dry_run = dry_run;
    this.overwrite = overwrite;
  }
}

function use_store_migrations(store_weaviate_migrations) {
  return $function.tap(
    $redraw.use_state(new $remote.NotLoaded()),
    (_use0) => {
      let set_weaviate_migrations = _use0[1];
      return ((_capture) => {
        return $redraw.use_effect(_capture, [store_weaviate_migrations]);
      })(() => { return set_weaviate_migrations(store_weaviate_migrations); });
    },
  );
}

function status_badge(status) {
  if (status instanceof $weaviate.Ongoing) {
    return $label.label(
      toList([$label.status(new $label.Current()), $label.content("Ongoing")]),
    );
  } else if (status instanceof $weaviate.Completed) {
    return $label.label(
      toList([$label.status(new $label.Success()), $label.content("Completed")]),
    );
  } else {
    return $label.label(
      toList([$label.status(new $label.Error()), $label.content("Failed")]),
    );
  }
}

function render_table(migrations) {
  return $table.table(
    toList([]),
    toList([
      $table.headers(
        toList([
          $table.header("Org ID"),
          $table.header("Run ID"),
          (() => {
            let _pipe = $table.header("Kind");
            return $table.fit(_pipe);
          })(),
          (() => {
            let _pipe = $table.header("Source");
            return $table.fit(_pipe);
          })(),
          (() => {
            let _pipe = $table.header("Target");
            return $table.fit(_pipe);
          })(),
          (() => {
            let _pipe = $table.header("Status");
            return $table.fit(_pipe);
          })(),
        ]),
      ),
      $table.body(
        $list.map(
          migrations,
          (migration) => {
            return $table.row(
              toList([
                $table.cell($h.text(migration.org_id)),
                $table.cell($h.text(migration.run_id)),
                $table.cell(
                  $h.text($weaviate.kind_to_string(migration.collection_kind)),
                ),
                $table.cell(
                  $h.text($weaviate.variant_to_string(migration.source_variant)),
                ),
                $table.cell(
                  $h.text($weaviate.variant_to_string(migration.target_variant)),
                ),
                $table.cell(status_badge(migration.status)),
              ]),
            );
          },
        ),
      ),
    ]),
  );
}

function migrations_table() {
  return $redraw.component_(
    "WeaviateMigrations(Table)",
    (_use0) => {
      let weaviate_migrations = _use0[0];
      if (weaviate_migrations instanceof $remote.NotLoaded) {
        return $skeleton.skeleton(600, 120);
      } else if (weaviate_migrations instanceof $remote.Loading) {
        return $skeleton.skeleton(600, 120);
      } else if (weaviate_migrations instanceof $remote.Errored) {
        let err = weaviate_migrations[0];
        return $callout.error(
          toList([]),
          toList([
            $callout.header(toList([]), toList([$h.text("Error")])),
            $callout.content(
              toList([]),
              toList([$h.text("Failed to load migrations: " + err)]),
            ),
          ]),
        );
      } else {
        let $ = weaviate_migrations[0];
        if ($ instanceof $Empty) {
          return $typography.text(
            $typography.sm,
            $typography.regular,
            "No migrations found.",
          );
        } else {
          let migrations = $;
          return render_table(migrations);
        }
      }
    },
  );
}

function form_toggler(label, active, on_change) {
  return $l.row(
    toList([$l.gap(12), $l.align("center")]),
    toList([]),
    toList([
      $h.text(label),
      $toggler.toggler(
        toList([$toggler.active(active), $toggler.on_change(on_change)]),
      ),
    ]),
  );
}

function previous_run_id_input(form, set_form) {
  return $input.input(
    (() => {
      let _pipe = $input.value(
        (() => {
          let _pipe = form.previous_run_id;
          return $option.unwrap(_pipe, "");
        })(),
      );
      let _pipe$1 = $input.label(_pipe, "Previous run id (Optional)");
      let _pipe$2 = $input.small(_pipe$1);
      let _pipe$3 = $input.type_(_pipe$2, "text");
      return $input.on_input(
        _pipe$3,
        (v) => {
          return set_form(
            new LaunchForm(
              form.collection_kind,
              form.source_variant,
              form.target_variant,
              new Some(v),
              form.batch_size,
              form.sleep,
              form.dry_run,
              form.overwrite,
            ),
          );
        },
      );
    })(),
  );
}

function sleep_time_input(form, set_form) {
  return $input.input(
    (() => {
      let _pipe = $input.value($int.to_string(form.sleep));
      let _pipe$1 = $input.label(_pipe, "Sleep (seconds)");
      let _pipe$2 = $input.small(_pipe$1);
      let _pipe$3 = $input.type_(_pipe$2, "number");
      return $input.on_input(
        _pipe$3,
        (v) => {
          let $ = $int.parse(v);
          if ($ instanceof Ok) {
            let n = $[0];
            return set_form(
              new LaunchForm(
                form.collection_kind,
                form.source_variant,
                form.target_variant,
                form.previous_run_id,
                form.batch_size,
                n,
                form.dry_run,
                form.overwrite,
              ),
            );
          } else {
            return undefined;
          }
        },
      );
    })(),
  );
}

function batch_size_input(form, set_form) {
  return $input.input(
    (() => {
      let _pipe = $input.value($int.to_string(form.batch_size));
      let _pipe$1 = $input.label(_pipe, "Batch");
      let _pipe$2 = $input.small(_pipe$1);
      let _pipe$3 = $input.type_(_pipe$2, "number");
      return $input.on_input(
        _pipe$3,
        (v) => {
          let $ = $int.parse(v);
          if ($ instanceof Ok) {
            let n = $[0];
            return set_form(
              new LaunchForm(
                form.collection_kind,
                form.source_variant,
                form.target_variant,
                form.previous_run_id,
                n,
                form.sleep,
                form.dry_run,
                form.overwrite,
              ),
            );
          } else {
            return undefined;
          }
        },
      );
    })(),
  );
}

function init_form() {
  return new LaunchForm(
    new Some(new $weaviate.Chunk()),
    new Some(new $weaviate.Base()),
    new Some(new $weaviate.V2()),
    new None(),
    50,
    1,
    false,
    false,
  );
}

function launch_form() {
  return $compose.children(
    $dropdown.dropdown(),
    (collection_kind_dropdown) => {
      return $compose.children(
        $dropdown.dropdown(),
        (source_dropdown) => {
          return $compose.children(
            $dropdown.dropdown(),
            (target_dropdown) => {
              return $redraw.component_(
                "Weaviate(Launch)",
                (_) => {
                  let dispatch_effect = $store.use_effect_dispatch();
                  let store = $store.use_state();
                  let $ = $redraw.use_state(init_form());
                  let form = $[0];
                  let set_form = $[1];
                  let _block;
                  let _pipe = $option.is_none(store.organization);
                  let _pipe$1 = $bool.or(
                    _pipe,
                    $option.is_none(form.collection_kind),
                  );
                  let _pipe$2 = $bool.or(
                    _pipe$1,
                    $option.is_none(form.source_variant),
                  );
                  let _pipe$3 = $bool.or(
                    _pipe$2,
                    $option.is_none(form.target_variant),
                  );
                  _block = $a.disabled(_pipe$3);
                  let disabled = _block;
                  let on_launch = $e.on_click(
                    (_) => {
                      let $1 = form.collection_kind;
                      let $2 = form.source_variant;
                      let $3 = form.target_variant;
                      if (
                        $1 instanceof Some &&
                        $2 instanceof Some &&
                        $3 instanceof Some
                      ) {
                        let collection_kind = $1[0];
                        let source_variant = $2[0];
                        let target_variant = $3[0];
                        dispatch_effect(
                          $migration_effects.launch_migration(
                            collection_kind,
                            source_variant,
                            target_variant,
                            form.batch_size,
                            form.sleep,
                            form.dry_run,
                            form.overwrite,
                            form.previous_run_id,
                          ),
                        );
                        return undefined;
                      } else {
                        return undefined;
                      }
                    },
                  );
                  return $card.card_custom_width(
                    1000,
                    toList([]),
                    toList([
                      $card.title(
                        toList([]),
                        toList([$h.text("Launch Migration")]),
                      ),
                      $card.body(
                        toList([]),
                        toList([
                          $l.column(
                            toList([$l.gap(16), $l.align("start")]),
                            toList([]),
                            toList([
                              $l.row(
                                toList([$l.gap(8)]),
                                toList([]),
                                toList([
                                  $l.column(
                                    toList([$l.gap(4)]),
                                    toList([]),
                                    toList([
                                      $typography.text(
                                        $typography.sm,
                                        $typography.medium,
                                        "Collection kind",
                                      ),
                                      (() => {
                                        let _pipe$4 = $dropdown.on_selected(
                                          (v) => {
                                            return set_form(
                                              new LaunchForm(
                                                v,
                                                form.source_variant,
                                                form.target_variant,
                                                form.previous_run_id,
                                                form.batch_size,
                                                form.sleep,
                                                form.dry_run,
                                                form.overwrite,
                                              ),
                                            );
                                          },
                                        );
                                        let _pipe$5 = $dropdown.placeholder(
                                          _pipe$4,
                                          "Select collection kind...",
                                        );
                                        let _pipe$6 = $dropdown.selected(
                                          _pipe$5,
                                          form.collection_kind,
                                        );
                                        let _pipe$7 = $dropdown.show_arrow(
                                          _pipe$6,
                                          true,
                                        );
                                        return collection_kind_dropdown(
                                          _pipe$7,
                                          $common.collection_kind_choices(),
                                        );
                                      })(),
                                    ]),
                                  ),
                                  $l.column(
                                    toList([$l.gap(4)]),
                                    toList([]),
                                    toList([
                                      $typography.text(
                                        $typography.sm,
                                        $typography.medium,
                                        "Source variant",
                                      ),
                                      (() => {
                                        let _pipe$4 = $dropdown.on_selected(
                                          (v) => {
                                            return set_form(
                                              new LaunchForm(
                                                form.collection_kind,
                                                v,
                                                form.target_variant,
                                                form.previous_run_id,
                                                form.batch_size,
                                                form.sleep,
                                                form.dry_run,
                                                form.overwrite,
                                              ),
                                            );
                                          },
                                        );
                                        let _pipe$5 = $dropdown.placeholder(
                                          _pipe$4,
                                          "Select source vriant...",
                                        );
                                        let _pipe$6 = $dropdown.selected(
                                          _pipe$5,
                                          form.source_variant,
                                        );
                                        let _pipe$7 = $dropdown.show_arrow(
                                          _pipe$6,
                                          true,
                                        );
                                        return source_dropdown(
                                          _pipe$7,
                                          $common.variant_choices(),
                                        );
                                      })(),
                                    ]),
                                  ),
                                  $l.column(
                                    toList([$l.gap(4)]),
                                    toList([]),
                                    toList([
                                      $typography.text(
                                        $typography.sm,
                                        $typography.medium,
                                        "Target variant",
                                      ),
                                      (() => {
                                        let _pipe$4 = $dropdown.on_selected(
                                          (v) => {
                                            return set_form(
                                              new LaunchForm(
                                                form.collection_kind,
                                                form.source_variant,
                                                v,
                                                form.previous_run_id,
                                                form.batch_size,
                                                form.sleep,
                                                form.dry_run,
                                                form.overwrite,
                                              ),
                                            );
                                          },
                                        );
                                        let _pipe$5 = $dropdown.placeholder(
                                          _pipe$4,
                                          "Select target variant...",
                                        );
                                        let _pipe$6 = $dropdown.selected(
                                          _pipe$5,
                                          form.target_variant,
                                        );
                                        let _pipe$7 = $dropdown.show_arrow(
                                          _pipe$6,
                                          true,
                                        );
                                        return target_dropdown(
                                          _pipe$7,
                                          $common.variant_choices(),
                                        );
                                      })(),
                                    ]),
                                  ),
                                ]),
                              ),
                              $l.row(
                                toList([$l.gap(8)]),
                                toList([]),
                                toList([
                                  batch_size_input(form, set_form),
                                  sleep_time_input(form, set_form),
                                  previous_run_id_input(form, set_form),
                                ]),
                              ),
                              $l.row(
                                toList([$l.gap(8)]),
                                toList([]),
                                toList([
                                  form_toggler(
                                    "Dry run",
                                    form.dry_run,
                                    (v) => {
                                      return set_form(
                                        new LaunchForm(
                                          form.collection_kind,
                                          form.source_variant,
                                          form.target_variant,
                                          form.previous_run_id,
                                          form.batch_size,
                                          form.sleep,
                                          v,
                                          form.overwrite,
                                        ),
                                      );
                                    },
                                  ),
                                  form_toggler(
                                    "Overwrite target",
                                    form.overwrite,
                                    (v) => {
                                      return set_form(
                                        new LaunchForm(
                                          form.collection_kind,
                                          form.source_variant,
                                          form.target_variant,
                                          form.previous_run_id,
                                          form.batch_size,
                                          form.sleep,
                                          form.dry_run,
                                          v,
                                        ),
                                      );
                                    },
                                  ),
                                ]),
                              ),
                            ]),
                          ),
                        ]),
                      ),
                      $card.footer(
                        toList([]),
                        toList([
                          $l.row(
                            toList([
                              $l.gap(16),
                              $l.styles(toList([$css.margin_top_("9px")])),
                            ]),
                            toList([]),
                            toList([
                              $button.primary(
                                toList([disabled, on_launch]),
                                toList([$h.text("Launch migration")]),
                              ),
                            ]),
                          ),
                        ]),
                      ),
                    ]),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function collection_name(org_id, kind, variant) {
  return (org_id + (() => {
    if (kind instanceof $weaviate.Document) {
      return "_document";
    } else {
      return "";
    }
  })()) + (() => {
    if (variant instanceof $weaviate.Base) {
      return "";
    } else {
      return "_" + $weaviate.variant_to_string(variant);
    }
  })();
}

function create_collection_form() {
  return $compose.children(
    $dropdown.dropdown(),
    (kind_dropdown) => {
      return $compose.children(
        $dropdown.dropdown(),
        (variant_dropdown) => {
          return $redraw.component_(
            "Weaviate(CreateCollection)",
            (org_id) => {
              let dispatch_effect = $store.use_effect_dispatch();
              let $ = $redraw.use_state(
                new CreateCollectionForm(
                  new $weaviate.Chunk(),
                  new $weaviate.Base(),
                ),
              );
              let form = $[0];
              let set_form = $[1];
              let on_submit = $e.on_click(
                (_) => {
                  dispatch_effect(
                    $migration_effects.create_collection(
                      org_id,
                      form.kind,
                      form.variant,
                    ),
                  );
                  return undefined;
                },
              );
              return $card.card_custom_width(
                2000,
                toList([]),
                toList([
                  $card.title(
                    toList([]),
                    toList([$h.text("Create collection")]),
                  ),
                  $card.body(
                    toList([]),
                    toList([
                      $l.row(
                        toList([$l.gap(16), $l.align("end")]),
                        toList([]),
                        toList([
                          $l.column(
                            toList([$l.gap(4)]),
                            toList([]),
                            toList([
                              $typography.text(
                                $typography.sm,
                                $typography.medium,
                                "Kind",
                              ),
                              (() => {
                                let _pipe = $dropdown.on_selected_(
                                  (kind) => {
                                    return set_form(
                                      new CreateCollectionForm(
                                        kind,
                                        form.variant,
                                      ),
                                    );
                                  },
                                );
                                let _pipe$1 = $dropdown.selected(
                                  _pipe,
                                  new Some(form.kind),
                                );
                                let _pipe$2 = $dropdown.show_arrow(
                                  _pipe$1,
                                  true,
                                );
                                return kind_dropdown(
                                  _pipe$2,
                                  $common.collection_kind_choices(),
                                );
                              })(),
                            ]),
                          ),
                          $l.column(
                            toList([$l.gap(4)]),
                            toList([]),
                            toList([
                              $typography.text(
                                $typography.sm,
                                $typography.medium,
                                "Variant",
                              ),
                              (() => {
                                let _pipe = $dropdown.on_selected_(
                                  (variant) => {
                                    return set_form(
                                      new CreateCollectionForm(
                                        form.kind,
                                        variant,
                                      ),
                                    );
                                  },
                                );
                                let _pipe$1 = $dropdown.selected(
                                  _pipe,
                                  new Some(form.variant),
                                );
                                let _pipe$2 = $dropdown.show_arrow(
                                  _pipe$1,
                                  true,
                                );
                                return variant_dropdown(
                                  _pipe$2,
                                  $common.variant_choices(),
                                );
                              })(),
                            ]),
                          ),
                          $button.primary(
                            toList([on_submit]),
                            toList([$h.text("Create")]),
                          ),
                        ]),
                      ),
                      $card.footer(
                        toList([]),
                        toList([
                          $h.text("Name: "),
                          $h.text(
                            collection_name(org_id, form.kind, form.variant),
                          ),
                        ]),
                      ),
                    ]),
                  ),
                ]),
              );
            },
          );
        },
      );
    },
  );
}

function collections_browser() {
  return $redraw.component_(
    "Weaviate(CollectionsBrowser)",
    (_) => {
      let store = $store.use_state();
      return $when.some_(
        $store.current_organization(store),
        () => { return $skeleton.skeleton(600, 40); },
        (org) => {
          let _block;
          let _pipe = $dict.get(store.weaviate_collections, org.id);
          _block = $result.unwrap(_pipe, new $remote.Loading());
          let collections = _block;
          if (collections instanceof $remote.NotLoaded) {
            return $skeleton.skeleton(600, 40);
          } else if (collections instanceof $remote.Loading) {
            return $skeleton.skeleton(600, 40);
          } else if (collections instanceof $remote.Errored) {
            let err = collections[0];
            return $callout.error(
              toList([]),
              toList([
                $callout.header(toList([]), toList([$h.text("Error")])),
                $callout.content(toList([]), toList([$h.text(err)])),
              ]),
            );
          } else {
            let $ = collections[0];
            if ($ instanceof $Empty) {
              return $typography.text(
                $typography.sm,
                $typography.regular,
                "No collections found.",
              );
            } else {
              let cols = $;
              return $redraw.keyed(
                (_capture) => {
                  return $l.row(
                    toList([$l.wrap("wrap"), $l.gap(6)]),
                    toList([]),
                    _capture,
                  );
                },
                $list.map(
                  cols,
                  (c) => {
                    return [
                      c.index_name,
                      $label.label(
                        toList([
                          $label.status(new $label.Neutral()),
                          $label.content(
                            (c.index_name + " · ") + $int.to_string(
                              c.nb_objects,
                            ),
                          ),
                        ]),
                      ),
                    ];
                  },
                ),
              );
            }
          }
        },
      );
    },
  );
}

export function view() {
  return $compose.static$(
    collections_browser(),
    (collections_browser) => {
      return $redraw.compose(
        create_collection_form(),
        (create_collection_form) => {
          return $redraw.compose(
            launch_form(),
            (launch_form) => {
              return $redraw.compose(
                migrations_table(),
                (migrations_table) => {
                  return $redraw.component_(
                    "Weaviate",
                    (_) => {
                      let store = $store.use_state();
                      let weaviate_migrations = $store.organization_weaviate_migrations(
                        store,
                      );
                      let $ = use_store_migrations(weaviate_migrations);
                      let weaviate_migrations$1 = $[0];
                      let set_weaviate_migrations = $[1];
                      return $l.column(
                        toList([$l.gap(32), $l.align("start")]),
                        toList([]),
                        toList([
                          $typography.h1($typography.md, "Weaviate Migrations"),
                          $l.column(
                            toList([$l.gap(48), $l.align("start")]),
                            toList([]),
                            toList([
                              $l.column(
                                toList([$l.gap(12)]),
                                toList([]),
                                toList([
                                  $typography.h2(
                                    $typography.xs,
                                    "Browse collections",
                                  ),
                                  collections_browser(),
                                ]),
                              ),
                              (() => {
                                let $1 = store.organization;
                                if ($1 instanceof Some) {
                                  let org_id = $1[0];
                                  return create_collection_form(org_id);
                                } else {
                                  return $h.none();
                                }
                              })(),
                              launch_form(undefined),
                              $l.column(
                                toList([$l.gap(12)]),
                                toList([]),
                                toList([
                                  $typography.h2(
                                    $typography.xs,
                                    "Current migrations",
                                  ),
                                  migrations_table(
                                    [
                                      weaviate_migrations$1,
                                      set_weaviate_migrations,
                                    ],
                                  ),
                                ]),
                              ),
                            ]),
                          ),
                        ]),
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
